import {
  AccordionActions as MUIAccordionActions,
  type AccordionActionsProps,
} from '@mui/material';

export { type AccordionActionsProps } from '@mui/material';

export function AccordionActions(props: AccordionActionsProps) {
  return <MUIAccordionActions {...props} />;
}
